import theme from '@corabank/design-tokens/build/tokens/colors.json'
import { Alert, Check } from '@corabank/icons'

import * as Styled from './styles'

export const INFO_PAGE_TEXTS = {
  PENDING_DOCUMENT: {
    ICON: (
      <Styled.InfoPageCircle backgroundColor={theme.softFillsLightAlert}>
        <Alert size="large" color={theme.contentLightBackgroundFeedbackAlert} />
      </Styled.InfoPageCircle>
    ),
    METRIC: 'up_documento: viu [tela_doc_enviado_sucesso_pendencia]',
    TITLE: (amount: number) =>
      `Documento${amount > 1 ? 's' : ''} enviado${
        amount > 1 ? 's' : ''
      } porém ainda tem uma ação pendente em seu cadastro`,
    TEXT: () =>
      'Para que seu cadastro seja analisado, você precisa acessar seu aplicativo e enviar novamente um documento pessoal.',
  },
  DOCUMENT_SENT: {
    ICON: (
      <Styled.InfoPageCircle backgroundColor={theme.softFillsLightPositive}>
        <Check
          size="large"
          color={theme.contentLightBackgroundFeedbackPositive}
        />
      </Styled.InfoPageCircle>
    ),
    METRIC: 'up_documento: viu [tela_doc_enviado_sucesso]',
    TITLE: (amount: number) =>
      `Documento${amount > 1 ? 's' : ''} enviado${
        amount > 1 ? 's' : ''
      } para análise`,
    TEXT: (amount: number) =>
      `Nosso time está analisando o${amount > 1 ? 's' : ''} documento${
        amount > 1 ? 's' : ''
      }. Você pode acompanhar a análise através do aplicativo Cora. Se for necessário, podemos pedir um novo reenvio.`,
  },
  IN_ANALYSIS: {
    ICON: (
      <Styled.InfoPageCircle backgroundColor={theme.softFillsLightPositive}>
        <Check
          size="large"
          color={theme.contentLightBackgroundFeedbackPositive}
        />
      </Styled.InfoPageCircle>
    ),
    METRIC: '',
    TITLE: () => 'Documento solicitado por aqui já foi enviado',
    TEXT: () =>
      'Você pode acompanhar a análise ou mais solicitações através do aplicativo Cora.',
  },
  FINALIZED: {
    ICON: (
      <Styled.InfoPageCircle backgroundColor={theme.softFillsLightPositive}>
        <Check
          size="large"
          color={theme.contentLightBackgroundFeedbackPositive}
        />
      </Styled.InfoPageCircle>
    ),
    METRIC: '',
    TITLE: () => 'Você já pode acessar a conta da sua empresa',
    TEXT: () => 'Aproveite todos os benefícios que o banco Cora oferece.',
    BUTTON_LABEL: 'Acessar conta',
  },
}

export const INFO_PAGE_LINKS = {
  PRODUCTION: 'https://app.cora.com.br/',
  STAGE: 'https://app.stage.cora.local/',
}
